import React, { type ReactNode } from 'react';
import { Box, xcss } from '@atlaskit/primitives';

export const ResizedImageWrapper = ({ children }: { children: ReactNode }) => (
	<Box xcss={image2ResizeStyles}>{children}</Box>
);

const image2ResizeStyles = xcss({
	width: '50%',
	margin: 'auto',
});
